import { Component, EventEmitter, Output } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SharedModule } from 'primeng/api';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'ct-extraction-discard-table-dialog',
  imports: [ConfirmDialogModule, SharedModule, DialogComponent],
  templateUrl: './discard-table-dialog.component.html',
})
export class DiscardTableDialogComponent {
  @Output() acceptedDialog = new EventEmitter<void>();
}
